<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.tile" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="tile" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="8" sm24>
        <card align="center">
          <card-text>
            <avatar
              color="white"
              font-size="xl"
              elevation="lg"
              :size="size"
              :tile="tile"
              :bg-color="$root.colors.primary"
              :text="$config.appNameAbbr"
              :color-lightness="null"
              :class="['my-6']"
              :bg-color-lightness="$root.colors.bgColorLightness" />
          </card-text>
        </card>
      </flex-col>
      <flex-col :span="8" sm24>
        <card align="center">
          <card-text>
            <avatar
              color="white"
              font-size="xl"
              icon="home"
              elevation="lg"
              :icon-size="4"
              :size="size"
              :tile="tile"
              :bg-color="$root.colors.primary"
              :text="$config.appNameAbbr"
              :color-lightness="null"
              :class="['my-6']"
              :bg-color-lightness="$root.colors.bgColorLightness" />
          </card-text>
        </card>
      </flex-col>
      <flex-col :span="8" sm24>
        <card align="center">
          <card-text>
            <avatar
              color="white"
              font-size="xl"
              elevation="lg"
              :size="size"
              :tile="tile"
              :bg-color="$root.colors.primary"
              :src="`${$root.config.staticAssetsDir}/images/avatars/avatar-01.png`"
              :color-lightness="null"
              :class="['my-6']"
              :bg-color-lightness="$root.colors.bgColorLightness" />
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageAvatar',
  data () {
    return {
      tile: false,
      size: '128px'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/avatar.vue